import { api, extractListItems, type ApiResponse } from './client';
import { type DonationRequest, type Statistics } from './admin/donation.service';

// Define interface for employer data
export interface Employer {
  uuid: string;
  name: string;
  abn: string;
  contact_name: string;
  contact_email: string;
  contact_phone: string;
  head_office_location: string;
}

// Define a basic interface for DonationRequest data
// Adjust this based on your actual DonationRequest model structure



export interface DashboardData {
  employers: Employer[];
  recent_donation_requests: DonationRequest[];
  statistics: Statistics;
}

export const EmployerService = {
  /**
   * Get all employers for the current user
   */
  getUserEmployers: async (user_uuid: string): Promise<{ employers?: Employer[]; success: boolean; error?: any }> => {
    try {
      const response = await api.get<ApiResponse<Employer[]>>(`/user/${user_uuid}/employers`);
      const employers = extractListItems<Employer>(response.data.data);
      return { 
        employers, 
        success: true 
      };
    } catch (error) {
      console.error('Error fetching user employers:', error);
      return { 
        success: false, 
        error 
      };
    }
  },

  /**
   * Get dashboard data: user's employers and recent donation requests for the first employer.
   */
  getDashboardData: async (user_uuid: string, employer_uuid?: string): Promise<{ data?: DashboardData; success: boolean; error?: any }> => {
    try {
      // Build the URL with optional employer_uuid parameter
      let url = `/user-dashboard/${user_uuid}`;
      if (employer_uuid) {
        url += `?employer_uuid=${employer_uuid}`;
      }
      
      const response = await api.get<ApiResponse<DashboardData>>(url);
      return {
        data: response.data.data, // The actual data is nested under 'data' from the controller
        success: true,
      };
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      return {
        success: false,
        error,
      };
    }
  },
};